import React from "react";
import Tooltip from "@mui/material/Tooltip";
import "./CustomTooltip.styles.css";

const CustomToolTip = (props) => {
  if (!props?.disableTooltip) {
    return (
      <Tooltip title={props.title} placement={props.placement} arrow>
        {props.children}
      </Tooltip>
    );
  } else {
    return props.children;
  }
};

CustomToolTip.defaultProps = {
  title: "",
  placement: "bottom-start",
  disableTooltip: false,
};

export default CustomToolTip;
